import { createGetServerSidePropsWithMessages } from "@utils/translates";
import type { PageWithLayout, PageProps } from "@types";
import { embedLayout } from "@layouts/default-layout";
import EmbeddedVideoTemplate from "@templates/embedded-video";
import Page from "@layouts/page";
import type { Meta } from "@layouts/page";
import { useRouter } from "next/router";
import useRequestImmutable from "@shared/hooks/useRequestImmutable";
import courseApi from "@api/course";
import { useTranslations } from "next-intl";
import { toFarsiNumber } from "@utils/digits";
import { SITE_URL } from "@utils/constants";

interface Props extends PageProps {}

const EmbeddedVideoPage: PageWithLayout<Props> = () => {
  const t = useTranslations("meta");
  const { query } = useRouter();

  const hasValidSlug = Boolean(query?.slug && typeof query.slug === "string");
  const querySlug: string | null = hasValidSlug ? String(query.slug) : null;

  const { data } = useRequestImmutable(
    querySlug
      ? courseApi.getCourseData(querySlug, {
          showProduct: 1,
        })
      : null
  );

  const meta: Meta = {
    title: toFarsiNumber(data?.product.seo_title || t("title")),
    description: toFarsiNumber(data?.product.seo_metadesc || t("desc")),
    lite: true,
    canonical: querySlug ? `${SITE_URL}/videos/${querySlug}` : undefined,
  };
  return (
    <Page meta={meta}>
      <EmbeddedVideoTemplate />
    </Page>
  );
};
EmbeddedVideoPage.isLiteEmbed = true;
EmbeddedVideoPage.getLayout = (page, props) => embedLayout(page, { ...props });

export default EmbeddedVideoPage;

export const getServerSideProps =
  createGetServerSidePropsWithMessages("course");
